import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", {
  class: "hidden sm:inline-block sm:align-middle sm:h-screen",
  "aria-hidden": "true"
}, "​", -1)
const _hoisted_3 = { class: "inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-md sm:w-full sm:p-6" }
const _hoisted_4 = { class: "mt-2 text-center sm:mt-5" }
const _hoisted_5 = { class: "mt-3 flex flex-col gap-y-4" }
const _hoisted_6 = { class: "mr-40" }
const _hoisted_7 = ["placeholder"]
const _hoisted_8 = { class: "mr-28" }
const _hoisted_9 = ["placeholder"]
const _hoisted_10 = { class: "mr-44" }
const _hoisted_11 = { class: "flex justify-center" }
const _hoisted_12 = { class: "mr-40" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "mr-24" }
const _hoisted_15 = ["src"]
const _hoisted_16 = { class: "mr-28" }
const _hoisted_17 = { class: "mt-5 sm:mt-6 text-center" }

import { computed, inject, ref } from "vue";
import {
  Dialog,
  DialogTitle,
  DialogOverlay,
  TransitionRoot,
  TransitionChild,
  Switch,
} from "@headlessui/vue";
import { AxiosInstance } from "axios";
import { translate } from "../../utils/tools";
import DropdownComponent from "../tools/DropdownComponent.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'LoyaltyCategoryCreateDialog',
  props: {
  show: Boolean,
},
  emits: [
  "submit",
  "update:show",
  "update:form",
  "created",
  "update:trackingNumber",
],
  setup(__props, { emit }) {

const props = __props

const axios = inject("$axios") as AxiosInstance;
const file = ref();
const showSync = computed({
  get: () => props.show,
  set: (value) => emit("update:show", value),
});
const category = ref({
  //   id: props.form?.id,
  name: "",
  imageUrl: "",
  isActive: false,
  type: "",
  description: ""
});
const preview = ref();

const selectedType = ref({
  label: translate("messages.rewardRedemption.selectType"),
  value: "SELECT TYPE",
});
const rewardTypeOptions = ref([
  { label: translate("messages.rewardRedemption.normal"), value: "NORMAL" },
  { label: translate("messages.rewardRedemption.fortuneWheel"), value: "FORTUNE_WHEEL" },
  { label: translate("messages.rewardRedemption.cash"), value: "CASH" },
]);

const onSelectedType = (e: any) => {
  category.value.type = e.value;
  selectedType.value = e;
};

const onCreate = async () => {
  try {
    await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/loyalty/api/internal/category`,
      category.value
    );

  } catch (error) {
    alert(error)
  }

  emit("created");
  showSync.value = false;
};


const onClose = () => {
  category.value.imageUrl = "";
  preview.value = "";
  showSync.value = false;
};

const onFileSelected = async (e: any) => {
  // const reader = new FileReader();
  const formData = new FormData();
  const files = file.value.files;
  formData.append("file", files[0]);
  formData.append("uploadType", "reward");
  // waiting for return imageurl

  // reader.readAsDataURL(files[0]);
  // reader.onloadend = (e) => (preview.value = reader.result);

  try {
    const image = await uploadPic(formData);

    if (image && image.data.imageUrl) {
      category.value.imageUrl = image.data.imageUrl;
      preview.value = image.data.imageUrl;
    }
  } catch (error) {
    alert(error);
  }
};

const uploadPic = async (formData: FormData) => {
  return await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/loyalty-upload/api/internal/upload/image`,
    formData,
    {
      headers: { "Content-Type": "multipart/form-data" },
    }
  );
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(TransitionRoot), {
      as: "template",
      show: _unref(showSync),
      static: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Dialog), {
          as: "div",
          static: "",
          class: "fixed z-10 inset-0 overflow-y-auto",
          onClose: _cache[7] || (_cache[7] = ($event: any) => (showSync.value = false)),
          open: _unref(showSync)
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_unref(TransitionChild), {
                as: "template",
                enter: "ease-out duration-300",
                "enter-from": "opacity-0",
                "enter-to": "opacity-100",
                leave: "ease-in duration-200",
                "leave-from": "opacity-100",
                "leave-to": "opacity-0"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(DialogOverlay), { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" })
                ]),
                _: 1
              }),
              _hoisted_2,
              _createVNode(_unref(TransitionChild), {
                as: "template",
                enter: "ease-out duration-300",
                "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                "enter-to": "opacity-100 translate-y-0 sm:scale-100",
                leave: "ease-in duration-200",
                "leave-from": "opacity-100 translate-y-0 sm:scale-100",
                "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_4, [
                        _createVNode(_unref(DialogTitle), {
                          as: "h3",
                          class: "text-lg leading-6 font-medium text-gray-900"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("messages.rewardCategory.createCategory")), 1)
                          ]),
                          _: 1
                        }),
                        _createElementVNode("div", _hoisted_5, [
                          _createElementVNode("div", null, [
                            _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t("messages.rewardCategory.name")), 1),
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              class: "rounded",
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((category.value.name) = $event)),
                              placeholder: _ctx.$t('messages.rewardCategory.categoryName')
                        
                            }, null, 8, _hoisted_7), [
                              [_vModelText, category.value.name]
                            ])
                          ]),
                          _createElementVNode("div", null, [
                            _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$t("messages.rewardCategory.description")), 1),
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              class: "rounded",
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((category.value.description) = $event)),
                              placeholder: _ctx.$t('messages.rewardCategory.descriptionName')
                        
                            }, null, 8, _hoisted_9), [
                              [_vModelText, category.value.description]
                            ])
                          ]),
                          _createElementVNode("div", null, [
                            _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.$t("messages.rewardCategory.type")), 1),
                            _createElementVNode("div", _hoisted_11, [
                              _createVNode(DropdownComponent, {
                                class: "w-52",
                                options: rewardTypeOptions.value,
                                modelValue: selectedType.value,
                                onOnOptionSelected: onSelectedType
                              }, null, 8, ["options", "modelValue"])
                            ])
                          ]),
                          _createElementVNode("div", null, [
                            _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.$t("messages.rewardCategory.image")), 1),
                            _createElementVNode("input", {
                              type: "file",
                              ref_key: "file",
                              ref: file,
                              class: "hidden",
                              onChange: onFileSelected
                            }, null, 544),
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              placeholder: "Click to upload",
                              class: "rounded border-dashed border-2 cursor-pointer",
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((category.value.imageUrl) = $event)),
                              onClick: _cache[3] || (_cache[3] = ($event: any) => ((_ctx.$refs as any).file.click()))
                            }, null, 512), [
                              [_vModelText, category.value.imageUrl]
                            ])
                          ]),
                          (preview.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.$t("messages.rewardCategory.previewImage")), 1),
                                _createElementVNode("img", {
                                  src: preview.value,
                                  class: "mx-auto w-52 h-52 object-contain"
                                }, null, 8, _hoisted_15)
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_16, [
                            _createTextVNode(_toDisplayString(_ctx.$t("messages.rewardCategory.active")) + " ", 1),
                            _createVNode(_unref(Switch), {
                              modelValue: category.value.isActive,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((category.value.isActive) = $event)),
                              class: _normalizeClass(["relative inline-flex h-6 w-11 items-center rounded-full", category.value.isActive ? 'bg-blue-400' : 'bg-red-500'
                          ])
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("span", {
                                  class: _normalizeClass([category.value.isActive
                            ? 'translate-x-6'
                            : 'translate-x-1'
                          , "inline-block h-4 w-4 transform rounded-full bg-white"])
                                }, null, 2)
                              ]),
                              _: 1
                            }, 8, ["modelValue", "class"])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (onClose())),
                        class: "mt-3 mr-2 inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:mt-0 sm:col-start-1 sm:text-sm"
                      }, _toDisplayString(_ctx.$t("messages.rewardCategory.close")), 1),
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (onCreate())),
                        class: "mt-3 ml-2 inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-blue-400 text-base font-medium text-white hover:bg-blue-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:mt-0 sm:col-start-1 sm:text-sm"
                      }, _toDisplayString(_ctx.$t("messages.rewardCategory.submit")), 1)
                    ])
                  ])
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["open"])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}
}

})